import RewardEntity from "./RewardEntity";

export default interface CustomerOfferEntity {
    startDate: string;
    endDate: string;
    rule: CustomerOfferRuleEntity | null;
    rewards: RewardEntity[];
}

export interface CustomerOfferRuleEntity {
    id: number;
    name: string;
    value: string;
}

let CustomerOfferRuleIds = {
    progressionBased: 1
};

export {CustomerOfferRuleIds};